










































import Vue from "vue";

export default Vue.extend({
    props: { showDialog: Boolean, loading: Boolean },
    computed: {
        showDeleteCaosUserSyncDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
            },
        },
    },
});
